import { ca } from '@cian/analytics';
//@ts-expect-error no types
import { ICommandPageviewData } from '@cian/analytics/dist/command';

export function trackPageview(eventData: ICommandPageviewData) {
  ca('pageview', eventData);
}
